//
/**
 * This file is shared between server and client.
 * ⚠️ DON'T PUT ANY NODE.JS OR BROWSER-SPECIFIC CODE IN HERE ⚠️
 *
 * Note: This uses Flow comment syntax so this whole file is actually valid JS without any transpilation
 * The reason I did that is because create-react-app doesn't transpile files outside the source folder,
 * so it chokes on the Flow syntax.
 * More info: https://flow.org/en/docs/types/comments/
 */

// Truncate a string nicely to a certain length
// function truncate(str /*: string */, length /*: number */) {
//   if (str.length <= length) {
//     return str;
//   }
//   var subString = str.substr(0, length);

//   // if the title doesn't have any spaces in it, just break at the normal length
//   if (subString.indexOf(' ') < 0) return subString + '…';

//   // if the title has a space character, attempt to break between words
//   return (
//     subString.substr(0, subString.lastIndexOf(' ')).replace(/\n/, ' ') + '…'
//   );
// }

function truncate(str, len) {
  var i = 0;
  var rtnStr = '';
  var subStr = '';
  if (getByteLength(str) <= len) return str;
  for (i = 0; i < getByteLength(str); i++) {
    subStr = str.substr(i, 1);
    if (getByteLength(subStr) == 2 && len >= 2) {
      rtnStr = rtnStr + subStr;
      len = len - 2;
    } else if (getByteLength(subStr) == 1 && len >= 1) {
      rtnStr = rtnStr + subStr;
      len = len - 1;
    } else if (getByteLength(subStr) == 2 && len < 2) {
      break;
    } else if (getByteLength(subStr) == 1 && len < 1) {
      break;
    }
  }
  return rtnStr + '…';
}
function getByteLength(str) {
  // eslint-disable-next-line no-control-regex
  let temp = str.replace(/[\x00-\xff]/g, 'a');
  temp = temp.replace(/[\uff61-\uff9f]/g, 'a');
  temp = temp.replace(/[\u3041-\u309f]/g, 'aa');
  temp = temp.replace(/[\u30a0-\u30ff]/g, 'aa');
  temp = temp.replace(/[^\x61-\x61]/g, 'aa');
  return temp.length;
}

module.exports = truncate;
